import { motion } from "framer-motion";
import { BookOpen, ArrowUpRight } from "@phosphor-icons/react";
import { useLang } from "../../context/LangContext";

const AMAZON_URL = "https://www.amazon.it/dp/B0HNHRXT7Q";

export const BookSection = () => {
  const { t } = useLang();
  const b = t.book;

  return (
    <section id="libro" className="bg-[#0A1428] py-24 sm:py-28" data-testid="book-section">
      <div className="mx-auto max-w-6xl px-6">
        <div className="grid items-center gap-12 lg:grid-cols-[320px_1fr] lg:gap-16">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="mx-auto w-64 sm:w-72 lg:w-full">
            <a href={AMAZON_URL} target="_blank" rel="noreferrer" data-testid="book-cover-link">
              <img src="/book/regolamento-macchine-cover.jpg" alt={b.title}
                className="w-full rounded-md shadow-[0_24px_60px_-12px_rgba(0,0,0,0.6)] ring-1 ring-white/10 transition-transform duration-300 hover:scale-[1.02]"
                data-testid="book-cover" />
            </a>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.12, ease: [0.16, 1, 0.3, 1] }}>
            <p className="inline-flex items-center gap-2 rounded-full border border-emerald-400/30 bg-emerald-400/10 px-3.5 py-1.5 font-mono-tech text-[11px] uppercase tracking-wider text-emerald-300">
              <BookOpen size={14} /> {b.badge}
            </p>
            <h2 className="mt-5 font-display text-3xl sm:text-4xl font-bold text-white leading-tight">{b.title}</h2>
            <p className="mt-2 text-lg text-emerald-300/90 font-medium">{b.subtitle}</p>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300">{b.desc}</p>
            <dl className="mt-7 grid grid-cols-2 gap-x-8 gap-y-3 max-w-md">
              {[[b.author, b.authorName], [b.publisher, b.publisherName], [b.date, b.dateValue], [b.format, b.formatValue]].map(([k, v]) => (
                <div key={k}>
                  <dt className="font-mono-tech text-[10px] uppercase tracking-wider text-slate-500">{k}</dt>
                  <dd className="text-sm font-semibold text-white">{v}</dd>
                </div>
              ))}
            </dl>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a href={AMAZON_URL} target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-emerald-500 px-7 py-3.5 text-sm font-semibold text-[#04170F] hover:bg-emerald-400 transition-colors"
                data-testid="book-amazon-btn">
                {b.cta} <ArrowUpRight size={16} />
              </a>
              <span className="text-xs text-slate-500">{b.note}</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
